var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniqueActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.999,
    height: 46.544,
    viewBox: "0 0 36.999 46.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sports-and-competition",
    transform: "translate(-52.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7372",
    "data-name": "Path 7372",
    d: "M147.452,405.864l-1.774-4.627-3.162,1.167,2.717,7.348c1.864-1.048,2.65-2.755,2.252-3.8Z",
    transform: "translate(-81.834 -364.761)",
    fill: "#ededed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7373",
    "data-name": "Path 7373",
    d: "M188.2,312.549l1.717-3.565c-1.5-.867-5.28-2.522-5.817-6.181l-.892,4.629-.481,2.5-5.436,1.82,1.774,4.627,7.891-2.726a1.9,1.9,0,0,0,1.244-1.1Z",
    transform: "translate(-113.45 -275.276)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7374",
    "data-name": "Path 7374",
    d: "M265.682,306.965l-4.226-4.162H252.2c.537,3.658,4.313,5.313,5.817,6.181l3.46,1.944,0,6.532H266.2v-8.608c0-1.025.08-1.3-.522-1.887Z",
    transform: "translate(-181.541 -275.276)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7375",
    "data-name": "Path 7375",
    d: "M362.174,467.474c.617-2.029-2.221-3.444-3.329-3.444h-4.737v.059l-.01,3.385h8.076Z",
    transform: "translate(-274.181 -421.846)",
    fill: "#ededed",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7376",
    "data-name": "Path 7376",
    d: "M250.487,166.956l.008-4.381-2.781-4.379a5.33,5.33,0,0,1-2.216.509,6.157,6.157,0,0,1-2.645-.542l-1.992,2.879a2.113,2.113,0,0,1,1.226,4.04l-1.966.674,1.1,5.556h9.261Z",
    transform: "translate(-170.565 -143.784)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7377",
    "data-name": "Path 7377",
    d: "M178.65,193.158a2.113,2.113,0,0,0-1.226-4.04c-.044.013-.09.026-.134.041l-5.529,1.9a2.118,2.118,0,0,0-1.421,1.916v5.52a2.113,2.113,0,1,0,4.226-.018l-.015-3.909,2.133-.731Z",
    transform: "translate(-107.128 -171.86)",
    fill: "#f9a720",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7378",
    "data-name": "Path 7378",
    d: "M359.381,169.049l3.059-4.353a2.107,2.107,0,1,0-3.467-2.4l-2.205,3.219-2.606-.013-.008,4.381,3.264,0c.982,0,1.36-.005,1.964-.836Z",
    transform: "translate(-274.231 -146.716)",
    fill: "#f9a720",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7379",
    "data-name": "Path 7379",
    d: "M247.3,64.759a6.149,6.149,0,0,0,3.668-5.4,5.913,5.913,0,0,0-1.532-3.979,10.868,10.868,0,0,1-4.866,1.454c-3.329.256-4.9,4.825-4.9,4.825a5.648,5.648,0,0,0,2.773,3.065,6.157,6.157,0,0,0,2.645.542,5.327,5.327,0,0,0,2.216-.509Z",
    transform: "translate(-170.154 -50.347)",
    fill: "#f9a720",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7380",
    "data-name": "Path 7380",
    d: "M242.553,14.2a2.831,2.831,0,0,0,.979-4.118c-3.575,1.789-5.714.617-7.727,1.332-3.475,1.234-4.575,4.327-3.023,9.065,0,0,1.576-4.57,4.9-4.825a10.868,10.868,0,0,0,4.866-1.454Z",
    transform: "translate(-163.268 -9.17)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4884",
    "data-name": "Group 4884",
    transform: "translate(52.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7381",
    "data-name": "Path 7381",
    d: "M121.038,41.267h-3.82l0-5.615a.917.917,0,0,0-.468-.8l-3.46-1.944h0c-.168-.1-.36-.2-.564-.312-1.422-.775-3.674-2-4.516-4.152h7.7l3.959,3.9c.256.252.256.252.25.906,0,.1,0,.209,0,.328v1.435a.917.917,0,1,0,1.833,0V33.576c0-.112,0-.215,0-.311a2.523,2.523,0,0,0-.8-2.23L117.2,27.144l.005-3.056,2.352,0a2.7,2.7,0,0,0,2.7-1.214l.009-.012,3.059-4.354a2.978,2.978,0,0,0,.49-2.252,3.02,3.02,0,0,0-5.465-1.188l-1.931,2.818-1.62-.008-1.992-3.135a6.892,6.892,0,0,0,3.29-5.727,6.833,6.833,0,0,0-1.173-3.833,3.952,3.952,0,0,0,.7-.919,3.786,3.786,0,0,0-.193-3.779A.916.916,0,0,0,116.227.1a8.912,8.912,0,0,1-4.385.975l-.447,0-.431,0a6.9,6.9,0,0,0-2.36.319c-2.318.823-5.864,3.242-3.593,10.2v0l0,.015c.008.024.017.047.026.07h0a6.858,6.858,0,0,0,2.3,3l-1.255,1.813-5.38,1.844a3.036,3.036,0,0,0-2.042,2.751c0,.011,0,.022,0,.033v1H93.427a.917.917,0,0,0,0,1.833h5.242v2.682a3.033,3.033,0,0,0,3.038,3.021h.013a3.029,3.029,0,0,0,3.007-3.043l-.013-3.251.518-.178.86,4.351-.714,3.71h-5.215a.917.917,0,0,0,0,1.834h4.862l-.17.883-4.929,1.65-.014.005-.012,0-3.162,1.167A.917.917,0,0,0,96.2,37.96l2.717,7.348a.917.917,0,0,0,1.309.481,4.977,4.977,0,0,0,2.822-4.081l7.139-2.467a2.8,2.8,0,0,0,1.769-1.57l1.289-2.676,1.571.9a.921.921,0,0,0,.222.092l.352.2,0,5.992h0l-.01,3.444a.917.917,0,0,0,.917.92h8.076a.917.917,0,0,0,.877-.65,2.878,2.878,0,0,0-.5-2.631A5.363,5.363,0,0,0,121.038,41.267ZM118.9,19.72a.917.917,0,0,0,.761-.4l2.206-3.22a1.187,1.187,0,0,1,1.648-.306,1.2,1.2,0,0,1,.5.782,1.157,1.157,0,0,1-.187.875L120.778,21.8c-.327.451-.331.45-1.219.453l-2.345,0,0-2.542ZM116.273,9.014a5.115,5.115,0,0,1-7.183,4.555c-.026-.014-.053-.027-.08-.038a4.572,4.572,0,0,1-2.126-2.24c.408-.956,1.775-3.719,3.978-3.888a13.334,13.334,0,0,0,4.566-1.176A5,5,0,0,1,116.273,9.014Zm-9.891-3.251a4.227,4.227,0,0,1,2.836-2.649,5.134,5.134,0,0,1,1.746-.213l.416,0,.462,0a10.948,10.948,0,0,0,4.308-.764,1.651,1.651,0,0,1-.122,1.24c-.7,1.282-3.242,2.035-5.306,2.192a6.217,6.217,0,0,0-4.524,3.11A6.4,6.4,0,0,1,106.382,5.762ZM103.5,21.835a.917.917,0,0,0-.62.871l.015,3.909a1.193,1.193,0,0,1-1.182,1.2h-.005a1.212,1.212,0,0,1-1.2-1.188v-3.5a.906.906,0,0,0,0-.192V21.128a1.209,1.209,0,0,1,.8-1.067l5.528-1.895a1.162,1.162,0,0,1,.377-.063,1.2,1.2,0,0,1,.39,2.327Zm4.693.33a3.03,3.03,0,0,0,.128-5.683L109,15.5a7.486,7.486,0,0,0,2.3.341,6.008,6.008,0,0,0,1.843-.3l2.237,3.522-.007,4.116h0l-.006,3.438H107.78l-.8-4.032Zm-7.974,21.386-1.984-5.366,1.451-.536,1.483,3.874C101.33,41.945,101.049,42.793,100.218,43.551ZM110.3,36.875a1,1,0,0,1-.718.634l-7.055,2.437-1.112-2.905,4.529-1.517a.917.917,0,0,0,.609-.7l.8-4.161a12.539,12.539,0,0,0,4.286,3.424Zm6.909,7.836,0-1.611h3.823a3.638,3.638,0,0,1,2.232,1.255,1.479,1.479,0,0,1,.2.356Z",
    transform: "translate(-88.873 0)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7382",
    "data-name": "Path 7382",
    d: "M129.755,345.19a.917.917,0,0,0,0-1.833h-.023a.917.917,0,0,0,0,1.833Z",
    transform: "translate(-121.877 -312.143)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383",
    "data-name": "Path 7383",
    d: "M53.44,243.247h-.023a.917.917,0,1,0,0,1.833h.023a.917.917,0,0,0,0-1.833Z",
    transform: "translate(-52.5 -221.134)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384",
    "data-name": "Path 7384",
    d: "M397.154,413.76a.917.917,0,0,0-.917.917v.023a.917.917,0,0,0,1.833,0v-.023A.917.917,0,0,0,397.154,413.76Z",
    transform: "translate(-364.989 -376.146)",
    fill: "#2b2b2b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueActivities);
export default __webpack_public_path__ + "static/media/unique-activities.3de35ca61ff44b38737c48a65d6fbdf1.svg";
export { ForwardRef as ReactComponent };